import { render, staticRenderFns } from "./MetadataPanel.vue?vue&type=template&id=45b50a44&scoped=true&"
import script from "./MetadataPanel.vue?vue&type=script&lang=js&"
export * from "./MetadataPanel.vue?vue&type=script&lang=js&"
import style0 from "./MetadataPanel.vue?vue&type=style&index=0&id=45b50a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b50a44",
  null
  
)

export default component.exports